<template>
  <li>
    <h3 class="ingredient--group" v-if="ingredient.is_group_title === true">
      {{ ingredient.group_title }}
    </h3>
    <div class="ingredient" v-else>
      <div class="ingredient__data" v-if="quantity()">
        <span class="ingredient__quantity">
          <IngredientCount
            :unit="ingredient.unit"
            :counter="counter"
            :quantity="ingredient.quantity"
            :nbPerson="nbPerson"
            :prefix="ingredient.prefix"
          />
        </span>
      </div>
      <div class="ingredient__text">
        <span class="ingredient__name"
          >{{ ingredient.prefix }} {{ ingredientName() }}</span
        >
      </div>
      <div class="ingredient__description" v-if="ingredient.description">
        {{ ingredient.description }}
      </div>
    </div>
  </li>
</template>
<script>
import IngredientCount from "./IngredientCount.vue";
Number.prototype.between = function(a, b) {
  var min = Math.min.apply(Math, [a, b]),
    max = Math.max.apply(Math, [a, b]);
  return this > min && this < max;
};
export default {
  components: { IngredientCount },
  name: "Ingredient",
  props: {
    ingredient: Object,
    nbPerson: Number,
    counter: Number
  },
  mounted() {},
  methods: {
    ingredientName() {
      return this.quantityRound() >= 2 && this.ingredient.name.plural
        ? this.ingredient.name.plural
        : this.ingredient.name.singular;
    },
    quantity() {
      return (this.counter / this.nbPerson) * this.ingredient.quantity;
    },
    quantityRound() {
      return Math.round(this.quantity() * 10) / 10;
    },
    quantityDisplay() {
      let withFraction = [false, "cup", "cs", "cc"];
      if (withFraction.includes(this.ingredient.unit)) {
        return this.numberToFraction();
      } else {
        return this.quantityRound();
      }
    },

    numberToFraction() {
      // ⅓, ⅔, ¼, ¾, ⅕, ⅖, ⅗, ⅘, ⅙, ⅚, ⅐, ⅛, ⅜, ⅝, ⅞, ⅑, ⅒, ⅟
      const amount = Math.round(this.quantity() * 100) / 100;
      const integerValue = Math.floor(amount);
      let decimalValue = amount - integerValue;
      // Fix javascript substraction bug (avoid number like 5.0000000001)
      decimalValue = parseFloat(decimalValue.toFixed(2));
      let fraction = false;
      switch (decimalValue) {
        case 0.13:
          fraction = "⅛";
          break;
        case 0.25:
          fraction = "¼";
          break;
        case 0.33:
          fraction = "⅓";
          break;
        case 0.5:
          fraction = "½";
          break;
        case 0.66:
          fraction = "⅔";
          break;
        case 0.75:
          fraction = "¾";
          break;
        default:
          return this.quantityRound();
      }
      const formatedFraction = "<sup>" + fraction + "</sup>";
      return integerValue ? integerValue + formatedFraction : formatedFraction;
    }
  }
};
</script>
<style lang="scss">
.ingredient {
  margin-bottom: 0.3em;
  display: flex;
  flex-wrap: wrap;
  &--group {
    font-family: omnes-pro, sans-serif;
    display: inline-block;
    margin: 15px 0 5px;
    border-bottom: 1px solid $black;
    font-size: 1em;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }
  .ingredient__qty,
  .ingredient__unit {
    font-weight: $bold;
  }
  &__data {
    display: block;
    margin-right: 0.2em;
  }
  &__description {
    font-size: 0.9em;
    display: block;
    color: $secondary;
    width: 100%;
  }
  sup {
    top: -0.3em;
    font-size: 90%;
  }
}
</style>
